/**
 * This file holds the actions/mutations types
 * For more information about why this is needed
 * check here https://vuex.vuejs.org/guide/mutations.html#using-constants-for-mutation-types
 */
export const SET_REGEX_REGION = "SET_REGEX_REGION";

export const CHANGE_VIEW = "CHANGE_VIEW";

export const NEXT_STEP = "NEXT_STEP";
export const BACK_STEP = "BACK_STEP";
export const RESET_STEP = "RESET_STEP";
export const SAVE_DATA = "SAVE_DATA";
export const DELETE_DATA = "DELETE_DATA";
export const RESET_DATA = "RESET_DATA";
export const RESTORE_DATA = "RESTORE_DATA";
export const SAVE_USER_DATA = "SAVE_USER_DATA";
export const LAST_STEP = "LAST_STEP";
export const SET_FONT_SIZE = "SET_FONT_SIZE";
export const CHANGE_COLOR = "CHANGE_COLOR";
export const ADD_PERSONALIZATION_COMPONENT = "ADD_PERSONALIZATION_COMPONENT";

export const GET_MODERATION_CHECK = "GET_MODERATION_CHECK";

export const SET_CHANGE_STYLE_FLOW = 'SET_CHANGE_STYLE_FLOW';
export const SET_PERSONALIZATION_POSITIONING =
  "SET_PERSONALIZATION_POSITIONING";